module.exports = __webpack_public_path__ + "img/phone-flip-duotone.0fc02ff7.svg";